import { Type } from "@angular/core";
import { IMeta } from "../i-meta";

export class ComponentMeta implements IMeta {
    public Name: string = '';
    public IsModal: boolean = false;
    public IsBeta: boolean = false;
    public Size: number = 0; //old property can be removed when v1 retired
    public Data = {};
    public IsFave: boolean = false; //old property can be removed when v1 retired
    public PageID: string = '';

    constructor(name: string) {
        this.Name = name;        
        this.IsModal = false;
        this.IsBeta = false;
        this.Data = {};
    }

    public copyFrom(comp: ComponentMeta) {
        if (!!comp) {            
            this.IsBeta = comp.IsBeta;           
            this.IsModal = comp.IsModal;         
            this.Data = comp.Data;
            this.PageID = comp.PageID;
        }
    }
}

export class ComponentData {
    constructor(
        public module: string, 
        public component: Type<any>,
        public meta: ComponentMeta,
    ) { }

    public get Size(): number {
        return this.meta.Size;
    }
    public set Size(value: number) {
        this.meta.Size = value;        
    }

    public get IsBeta(): boolean {
        return this.meta.IsBeta;
    }
    public set IsBeta(value: boolean) {
        this.meta.IsBeta = value;
    }

    public get IsModal(): boolean {
        return this.meta.IsModal;
    }

    public set IsModal(value: boolean) {
        this.meta.IsModal = value;
    }

    public get PageID(): string {
        return this.meta.PageID;
    }

}

export class ContentComponentData extends ComponentData {
    constructor(
        public contentType: string,
        public module: string,
        public component: Type<any>,
        public meta: ComponentMeta,
    ) { super(module, component, meta) }
}
